import {authMiddleware} from "./loginAction";
import cfg, {
  formatStatusError,
  handleResponse, UPDATE_CHAT_CLIENT, UPDATE_CHAT_CLIENT_NOTICE_ADD, UPDATE_CHAT_CLIENT_NOTICE_REMOVE,
  UPDATE_CHAT_CLIENT_REPORT,
  UPDATE_CHAT_CLIENT_REPORT_ID,
  UPDATE_CHAT_CLIENT_REPORTS,
  UPDATE_CHAT_CLIENT_ID,
  handlePrepareData,
  UPDATE_CHAT_AI_BATCH,
  UPDATE_CHAT_AI_BATCH_CLEAR,
} from "../constants";

// clientsAction - get users
export const clientsAction = (filter, isAdmin = false, signal, isTechnicalSpecialist = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + ((isAdmin || isTechnicalSpecialist) ? '/ba/' : '/auth/') + 'clients', {
    method: "POST",
    body: JSON.stringify(filter),
    headers,
    signal
  }).then(handleResponse).then(handlePrepareData);
};

// clientsGetAction - get user by ID
export const clientsGetAction = (id, isAdmin = false, isTechnicalSpecialist = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + ((isAdmin || isTechnicalSpecialist) ? '/ba/' : '/auth/') + 'client/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_CLIENT, client: data.item, course: data.get_course_data, notices: data.clients_notice || [], curator: data.curator, responseillness: data.response_illness, block_in_chat_boltalok_id_list: data.block_in_chat_boltalok_id_list});
      return data.item;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// clientsDeleteAction - delete user by ID
export const clientsDeleteAction = (id, isAdmin = false, isTechnicalSpecialist = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + ((isAdmin || isTechnicalSpecialist) ? '/ba/' : '/auth/') + 'client/' + id, {
    method: "DELETE",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientsMessageAction - send message to selected clients
export const clientsMessageAction = (form) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);
  return new Promise((resolve, reject) => {
    const formData = new FormData();

    if (form.file && form.file.name) {
      formData.append("file", form.file, form.file.name);
    }
    if (form.curator_id) {
      formData.append("curator_id", form.curator_id);
    }
    if (form.client_ids) {
      formData.append("client_ids", form.client_ids.join(','));
    }
    if (form.program_stages) {
      formData.append("program_stages", form.program_stages.join(','));
    }
    if (form.program_stages_weeks) {
      formData.append("program_stages_weeks", form.program_stages_weeks.join(','));
    }
    formData.append("message_text", form.message);
    formData.append("in_archive", form.in_archive);
    formData.append("course", form.course);
    
    formData.append("in_week", form.in_week);

    formData.append("last_message", form.last_message);

    const req = new XMLHttpRequest();
    req.addEventListener("load", event => {
      if (req.status === 200) {
        try {
          let data = JSON.parse(req.response);
          if (data.status === 'ok') {
            resolve(data);
          } else if (data.errors && data.errors.length > 0) {
            reject(new Error(data.errors[0]));
          } else {
            reject(new Error('error_other'));
          }
        } catch (e) {
          reject(new Error('error_other'));
        }
      } else {
        reject(formatStatusError(req.status));
      }
    });

    req.upload.addEventListener("error", event => {
      reject(req.response);
    });

    req.open("POST", cfg.base_url + '/auth/bulk-mailing');
    req.setRequestHeader("Authorization", 'Bearer ' + token);
    req.send(formData);
  });
};

// clientsCuratorAction - change users curator
export const clientsCuratorAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/client-change-curator', {
    method: "POST",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientBlockAction - block/unblock user
export const clientBlockAction = (client_id, block_clients, isAdmin = false, isTechnicalSpecialist = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + ((isAdmin || isTechnicalSpecialist) ? '/ba/' : '/auth/') + 'client-block', {
    method: "POST",
    body: JSON.stringify({client_id, block_clients}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientArchiveAction - to archive/from archive
export const clientArchiveAction = (client_id, archive, isAdmin = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + (isAdmin ? '/ba/' : '/auth/') + 'client-archive', {
    method: "POST",
    body: JSON.stringify({client_id, archive}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientEditAction - edit user common data
export const clientEditAction = (body, isAdmin = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + (isAdmin ? '/ba/' : '/auth/') + 'client', {
    method: "POST",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientDatesEditAction - edit user course dates
export const clientDatesEditAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/editing-start-date-course', {
    method: "POST",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientUpdateAction - change user data by ID (diseases, allergies and so on)
export const clientUpdateAction = (id, body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/clients-edit-health-questionnaire', {
    method: "POST",
    body: JSON.stringify({...body, id}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientsGetByCodeAction - get user by code from the link
export const clientsGetByCodeAction = (code) => () => {
  return fetch(cfg.base_url + '/auth/get-health-questionnaire/' + code, {
    method: "GET"
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      return data.item;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// clientUpdateByCodeAction - change user data by code from the link
export const clientUpdateByCodeAction = (code, body) => () => {
  return fetch(cfg.base_url + '/auth/save-health-questionnaire', {
    method: "POST",
    body: JSON.stringify({...body, code})
  }).then(handleResponse).then(handlePrepareData);
};

// clientControlCheckByCodeAction - get user by code from the control report link
export const clientControlCheckByCodeAction = (code) => () => {
  return fetch(cfg.base_url + '/auth/check-control-report/' + code, {
    method: "GET"
  }).then(handleResponse).then(handlePrepareData);
};

// clientControlSaveByCodeAction - save control report
export const clientControlSaveByCodeAction = (code, body) => () => {
  return fetch(cfg.base_url + '/auth/save-control-report', {
    method: "POST",
    body: JSON.stringify({...body, code})
  }).then(handleResponse).then(handlePrepareData);
};

// clientGetControlListAction - get client control reports by ID
export const clientGetControlListAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  fetch(cfg.base_url + '/auth/control-report-list/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_CLIENT_REPORTS, items: data.items || []});
    }
  }).catch((e) => {
    console.log('favorites remove error', e);
  });
};

// clientGetControlAction - get client control reports by client ID and report ID
export const clientGetControlAction = (id, clients_id) => (dispatch, getState) => {
  dispatch({type: UPDATE_CHAT_CLIENT_REPORT_ID, reportID: id})
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/control-report-one/' + clients_id + '/' + id, {
    method: "GET",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_CLIENT_REPORT, item: data.item});
      return true;
    }
    return false;
  }).catch((e) => {
    console.log('favorites remove error', e);
    return false;
  });
};

// clientNoticeAction - add notice to client by ID
export const clientNoticeAction = (id, clients_id, message) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/clients-notice', {
    method: "POST",
    body: JSON.stringify({id, clients_id, message}),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_CLIENT_NOTICE_ADD, item: data.item});
      return data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

// clientNoticeRemoveAction - remove notice by ID
export const clientNoticeRemoveAction = (id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/clients-notice/' + id + '/delete', {
    method: "DELETE",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_CLIENT_NOTICE_REMOVE, id});
      return data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

export const clientDelAction = (client_id, isAdmin = false) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + (isAdmin ? '/ba/' : '/auth/') + 'client-del', {
    method: "POST",
    body: JSON.stringify({client_id}),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
      dispatch({type: UPDATE_CHAT_CLIENT_ID});
      window.location.reload();
      return data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

export const clientDatesDelAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/del-start-date-course', {
    method: "POST",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok') {
        window.location.reload();
      return data;
    }
    if (data.errors && data.errors.length > 0) {
      throw new Error(data.errors[0]);
    }
    throw new Error('error_other');
  });
};

export const manualActivationClientAction = (client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/manual-client-activation', {
    method: "POST",
    body: JSON.stringify({client_id}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const manualSetCodeClientAction = (client_id, type_code) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/manual-client-set-code', {
    method: "POST",
    body: JSON.stringify({client_id, type_code}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const clientUnbanChatMemberAction = (client_id, chat_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/client-unban-chat-member', {
    method: "POST",
    body: JSON.stringify({client_id, chat_id}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const clientCheckChatMemberAction = (client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/client-check-chat-member', {
    method: "POST",
    body: JSON.stringify({client_id}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const clientGetOneChatAction = (client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/client-chat', {
    method: "POST",
    body: JSON.stringify({client_id}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

export const updateClientsFixCuratorAction = () => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/ba/update-clients-fix-curator', {
    method: "POST",
    body: JSON.stringify({}),
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// clientChannelAction - change client channel type (T = Telegram, M = Max)
export const clientChannelAction = (client_id, channel_type) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/client-channel/' + client_id + '/' + channel_type, {
    method: "POST",
    headers
  }).then(handleResponse).then(handlePrepareData);
};

// aiBatchGetAction - get last AI batch for client (custom 404 handling)
export const aiBatchGetAction = (client_id) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  // The curator may switch clients while the request is in flight. A response for the
  // previous client can land second and overwrite the current one's batch — the card would
  // then show someone else's suggestion and "Apply" would send it to the wrong client.
  // Such a response is dropped silently. We compare against chat.client specifically:
  // the card renders from it and sends its id.
  const isStale = () => {
    const cur = getState().chat.client;
    return !cur || String(cur.id) !== String(client_id);
  };
  return fetch(cfg.base_url + '/auth/ai/last-batch?client_id=' + encodeURIComponent(client_id), {
    method: "GET",
    headers
  }).then((response) => {
    if (response.status === 401) {
      window.location = '/login';
      return null;
    }
    if (isStale()) {
      return null;
    }
    if (response.status === 200) {
      return response.json().then((data) => {
        if (isStale()) {
          return null;
        }
        dispatch({type: UPDATE_CHAT_AI_BATCH, data});
        return data;
      });
    }
    dispatch({type: UPDATE_CHAT_AI_BATCH_CLEAR});
    return null;
  }).catch(() => {
    if (!isStale()) {
      dispatch({type: UPDATE_CHAT_AI_BATCH_CLEAR});
    }
    return null;
  });
};

// aiBatchReviewAudioAction - decline AI batch with audio comment (proxied through main server)
export const aiBatchReviewAudioAction = (clientId, batchEnd, audioBlob) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);
  const formData = new FormData();
  formData.append('file', audioBlob, 'review.webm');
  formData.append('client_id', clientId);
  formData.append('batch_end', batchEnd);
  formData.append('status', 'declined');

  return fetch(cfg.base_url + '/auth/ai/review-audio', {
    method: 'POST',
    headers: {'Authorization': 'Bearer ' + token},
    body: formData,
  }).then((response) => {
    if (response.status === 401) {
      window.location = '/login';
      throw new Error('Unauthorized');
    }
    if (!response.ok) throw new Error('Ошибка отправки аудио');
    return response.json();
  }).then((data) => {
    if (data.success) {
      dispatch({type: UPDATE_CHAT_AI_BATCH_CLEAR});
      return data;
    }
    throw new Error(data.error || 'Ошибка при обработке');
  });
};

// transcribeAudioAction - transcribe audio file only (no decline, no DB)
export const transcribeAudioAction = (audioBlob) => (dispatch, getState) => {
  const token = authMiddleware(dispatch, getState, false, true);
  const formData = new FormData();
  formData.append('file', audioBlob, 'audio.webm');

  return fetch(cfg.base_url + '/auth/ai/transcribe-audio', {
    method: 'POST',
    headers: {'Authorization': 'Bearer ' + token},
    body: formData,
  }).then((response) => {
    if (response.status === 401) {
      window.location = '/login';
      throw new Error('Unauthorized');
    }
    if (!response.ok) throw new Error('Ошибка транскрипции');
    return response.json();
  }).then((data) => {
    if (data.success) {
      return data.text;
    }
    throw new Error(data.error || 'Ошибка при транскрипции');
  });
};

// aiBatchReviewAction - approve or decline AI batch
export const aiBatchReviewAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/ai/review', {
    method: "POST",
    body: JSON.stringify(body),
    headers
  }).then(handleResponse).then((data) => {
    if (data.success) {
      dispatch({type: UPDATE_CHAT_AI_BATCH_CLEAR});
      return data;
    }
    throw new Error(data.error || 'Ошибка при обработке');
  });
};

// aiCardReviewAction - AI card review (Design3): never throws, so sending the message is
// not rolled back because of the review. Returns {success, transport, error}:
// transport:true means the request never reached gamma (network/5xx/401) and the review was
// not recorded, which the curator must be told; success:false without transport means the
// batch was already reviewed or is gone.
// body: {client_id, batch_end, status, final_text?, comment?}
export const aiCardReviewAction = (body) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  // empty final_text/comment are not sent: gamma gets exactly the same set of keys as from
  // the old UI, and never records an approval with an empty final text
  const payload = Object.keys(body).reduce((res, k) => {
    if (body[k] !== null && body[k] !== undefined && body[k] !== '') {
      res[k] = body[k];
    }
    return res;
  }, {});
  return fetch(cfg.base_url + '/auth/ai/review', {
    method: "POST",
    body: JSON.stringify(payload),
    headers
  }).then(handleResponse)
    .then((data) => ({success: !!(data && data.success), error: data && data.error}))
    .catch((e) => ({success: false, transport: true, error: e && e.message}));
};

// Impressions already reported in this page load: "{client_id}|{batch_end}|{event}".
// Module level on purpose: the card remounts when the curator enters edit mode and when a failed
// send restores the batch, and chat redux state is wiped on every client switch — neither could
// dedupe this.
const aiImpressionSent = new Set();

// aiImpressionReportAction - fire-and-forget impression telemetry for the AI card (Design3).
// Deliberately silent: never throws, never dispatches, never toasts. A lost impression is a lost
// data point, not something the curator can act on, and it must never interfere with answering.
// body: {client_id, batch_end, event, dwell_ms?, ratio?, via?}
export const aiImpressionReportAction = (body) => (dispatch, getState) => {
  const client_id = body && body.client_id;
  const batch_end = body && body.batch_end;
  const event = body && body.event;
  if (!client_id || !batch_end || !event) {
    return Promise.resolve({success: false, skipped: true});
  }
  const key = String(client_id) + '|' + String(batch_end) + '|' + event;
  if (aiImpressionSent.has(key)) {
    return Promise.resolve({success: true, skipped: true});
  }

  // isPublic, unlike every other action here: with the default authMiddleware navigates to /login
  // when localStorage holds no token, and this call fires on a timer. A curator logged out in
  // another tab would have this one yanked away mid-reply by a request they never made. Without a
  // token there is nobody to attribute the impression to, so it is dropped — and the key is not
  // marked, so a later mount with a valid session can still report it.
  const headers = authMiddleware(dispatch, getState, true);
  if (!headers || !headers.Authorization) {
    return Promise.resolve({success: false, skipped: true});
  }
  // marked before the request, not after: two mounts in the same tick must not both send
  aiImpressionSent.add(key);

  // same key-stripping as aiCardReviewAction: dwell_ms/ratio/via are simply absent on "shown"
  const payload = Object.keys(body).reduce((res, k) => {
    if (body[k] !== null && body[k] !== undefined && body[k] !== '') {
      res[k] = body[k];
    }
    return res;
  }, {});
  // Not handleResponse: it redirects to /login on 401. Every other action fires from a click, so
  // that redirect answers something the curator just did — this one fires on a timer, and a stale
  // token would throw them out of the page mid-work with a half-typed reply. Every non-200 is
  // dropped instead. On failure the key stays in the Set: telemetry is best-effort, and a broken
  // endpoint must not turn into a request storm across remounts.
  return fetch(cfg.base_url + '/auth/ai/impression', {
    method: "POST",
    body: JSON.stringify(payload),
    headers
  }).then((response) => ({success: response.status === 200}))
    .catch((e) => ({success: false, transport: true, error: e && e.message}));
};

// clientMergeMaxAction - merge client data with max account by phone
export const clientMergeMaxAction = (clientId, phone) => (dispatch, getState) => {
  const headers = authMiddleware(dispatch, getState);
  return fetch(cfg.base_url + '/auth/client-merge/' + clientId + '/' + encodeURIComponent(phone), {
    method: "POST",
    headers
  }).then(handleResponse).then((data) => {
    if (data.status === 'ok' || data.status === 'OK') {
      return data;
    }
    throw new Error(data.error || 'Ошибка при обработке');
  });
};